import { createContext, Dispatch, FC, ReactNode, SetStateAction, useState } from 'react';

type ITheme = 'light' | 'dark';

interface INavigationContext {
  theme: ITheme;
  setTheme: Dispatch<SetStateAction<ITheme>>;
}

export const NavigationContext = createContext<INavigationContext>({
  theme: 'light',
  setTheme: () => {
    //
  },
});

export const NavigationContextWrapper: FC<{ children: ReactNode }> = ({ children }) => {
  const [theme, setTheme] = useState<ITheme>('light');

  return (
    <NavigationContext.Provider value={{ theme, setTheme }}>{children}</NavigationContext.Provider>
  );
};
